import React from "react";
import PropTypes from "prop-types";
import { useFormik } from "formik";

import ImageCheckbox from "../components/ImageCheckbox";
import Button from "../components/Button";
import StepHeader from "../components/StepHeader";
import Animate from "../Animate";

import { FieldShape, ContentWithVarsShape } from "../utils/types";

export default function ImageChoice({
  id,
  fields = [],
  title = "",
  description = "",
  htmlContent = "",
  submitLabel = "",
  onSubmit,
  variables,
  emptyVariableFormatter,
}) {
  const formik = useFormik({
    initialValues: {
      selected: [],
    },
    onSubmit: (value) => onSubmit(value.selected, id),
    validate: (submitValues) => {
      if (submitValues.selected.length !== 0) {
        return {};
      }
      return { selected: true };
    },
  });

  React.useEffect(() => {
    validateForm();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { values, handleSubmit, isValid, validateForm } = formik;

  const disabledButton = !isValid;

  return (
    <Animate>
      <div className="grid grid-start">
        <div className="wide-container">
          <form onSubmit={handleSubmit}>
            <div className="image-choice-header">
              <div className="">
                <StepHeader
                  title={title}
                  description={description}
                  htmlContent={htmlContent}
                  variables={variables}
                  emptyVariableFormatter={emptyVariableFormatter}
                />
              </div>

              <Button
                label={submitLabel}
                sticky={true}
                type="submit"
                disabled={disabledButton}
              />
            </div>

            <div className="image-grid">
              {fields.map((field) => {
                return (
                  <ImageCheckbox
                    name={"selected"}
                    onChecked={(value) => {
                      formik.setFieldValue(
                        "selected",
                        value
                          ? [...values.selected, field.id]
                          : values.selected.filter((v) => v !== field.id),
                      );
                    }}
                    id={field.id}
                    key={field.id}
                    value={field.id}
                    src={field.imageSrc}
                    alt={field.label}
                    checked={values.selected.includes(field.id)}
                  />
                );
              })}
            </div>
          </form>
        </div>
      </div>
    </Animate>
  );
}

ImageChoice.propTypes = {
  id: PropTypes.string.isRequired,
  fields: PropTypes.arrayOf(FieldShape),
  title: ContentWithVarsShape,
  description: ContentWithVarsShape,
  htmlContent: PropTypes.string,
  submitLabel: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  variables: PropTypes.object.isRequired,
  emptyVariableFormatter: PropTypes.func,
};
